import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const StyledSticky = styled.div`
    width: 100%;
    z-index: 2;
    position: fixed;
    bottom: 0;
    background-color: ${({ theme }) => theme.color.secondary};
    ${mq.gt.sm} {
        display: none;
    }

    border-top: 1px solid #ececf0;
    padding: 8px 0;
    box-shadow: 0 0 8px 0 rgb(0 0 0 / 12%);
    display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;

export const StyledButtons = styled.div`
    div {
        margin: 8px auto;
    }
`;
